import React, { useEffect, useState } from "react";
import Loader from "../../components/shared/Loader";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { updateMeta } from "../../store/actions/metaAction";
import cookie from "js-cookie";
import server from "../../api/server";

const WhyUsShow = ({ match }) => {
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();
	const {
		params: { whyUsId },
	} = match;

	const { register, handleSubmit, setValue, reset } = useForm();

	const onStart = async () => {
		try {
			const initialData = await server(cookie).get(
				`/pages/why-us/sections/${whyUsId}`
			);
			setValue("description", initialData?.data?.data?.section?.description);
			setValue("title", initialData?.data?.data?.section?.title);
			setValue("sectionTitle", initialData?.data?.data?.section?.sectionTitle);
			setValue("icon", initialData?.data?.data?.section?.icon);
			dispatch(
				updateMeta({
					title: `${initialData?.data?.data?.section?.title}`,
					breadcrumb: "الانواع",
					button: {
						show: false,
						text: null,
						link: null,
					},
				})
			);
		} catch (error) {
			console.log(error);
		}
	};

	// handleMethods
	const submitHandler = async data => {
		setLoading(true);
		try {
			const finalData = {
				...data,
				description: data.description,
			};
			// eslint-disable-next-line no-unused-vars
			const dataResponse = await server(cookie).put(
				`/pages/why-us/sections/${whyUsId}`,
				{
					section: finalData,
				}
			);
			reset();
			onStart();
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	};

	// watchers
	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit(submitHandler)}>
				<div className="row">
					<div className="col-md-12">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="descriptionAr">الوصف باللغة العربية</label>
									<textarea
										name="descriptionAr"
										id="descriptionAr"
										cols="30"
										rows="10"
										{...register("description.ar", {
											required: true,
										})}
									/>
								</div>
							</div>
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="descriptionEn">الوصف بالغة الانجليزية</label>
									<textarea
										type="text"
										name="descriptionEn"
										id="descriptionEn"
										cols="30"
										rows="10"
										{...register("description.en", {
											required: true,
										})}
									/>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-12">
						<div className="form-item mt-3">
							<button className="bt bt-success btn-block" type="submit">
								ارسال
							</button>
						</div>
					</div>
				</div>
				<input
					type="text"
					name="title"
					id=""
					style={{ display: "none" }}
					{...register("title")}
				/>
				<input
					type="text"
					name="sectionTitle"
					id=""
					style={{ display: "none" }}
					{...register("sectionTitle")}
				/>
				<input
					type="text"
					name="icon"
					id=""
					style={{ display: "none" }}
					{...register("icon")}
				/>
			</form>
		</section>
	);
};
export default WhyUsShow;
